/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Cta_TitleInputs */

const en_svc_n8n_cta_title = /** @type {(inputs: Svc_N8n_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring the process you still do by hand.`)
};

const lv_svc_n8n_cta_title = /** @type {(inputs: Svc_N8n_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet procesu, ko joprojām darāt ar rokām.`)
};

/**
* | output |
* | --- |
* | "Bring the process you still do by hand." |
*
* @param {Svc_N8n_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_cta_title = /** @type {((inputs?: Svc_N8n_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_cta_title(inputs)
	return en_svc_n8n_cta_title(inputs)
});